<!--
 * @Author: your name
 * @Date: 2021-07-27 20:30:08
 * @LastEditTime: 2021-09-09 14:32:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\pages\exclusivePurchase\index.vue
-->
<template>
  <div>
    <el-card class="box-card">
      <slot></slot>
      <div class="box-card-content">
        <div class="box-card-title flex-sb">
          <p class="title">{{ activeType == 1 ? "" : "5." }}采购商城内容配置</p>
          <p v-if="activeType != 1">
            <i class="icon-circle" v-if="check1 == 1"></i>
            <i class="el-icon-circle-check icon-success" v-if="check1 == 2"></i>
            <i class="el-icon-circle-close icon-error" v-if="check1 == 3"></i>
          </p>
        </div>
        <div class="box-card-desc">
          在这里，您需要上传贵企业的采购专属商城中展示的企业Logo和轮播图片。
        </div>
        <!-- //////////////////////////////////////// -->
        <div class="upload-content">
          <div class="logo-box">
            <div class="tip-name">
              <span style="color:#f56c6c;margin-right:4px;">*</span>品牌Logo：
            </div>
            <div class="logo-img" v-if="formData.logoImgList.length">
              <el-image v-for="(item, index) in formData.logoImgList" :key="index" style="width: 150px:height:50px" :src="item"
                :preview-src-list="formData.logoImgList"></el-image>
              <div class="cover-bg">
                <p @click="clear()" class="cover-icon">
                  <i class="el-icon-close"></i>
                </p>
              </div>
            </div>
            <el-upload :limit="1" :show-file-list="false" :action="uploadImgUrl" :headers="header"
              :before-upload="beforeImgUpload" :on-success="handleSuccess">
              <div class="upload">
                {{ formData.logoImgList.length > 0 ? "替换" : "上传" }}
              </div>
            </el-upload>
          </div>
          <div class="text" style="margin:10px 0;">
            高度上限60px，宽度上限300px，仅支持.jpg/.jpeg/.png格式，图片大小不超过500K
          </div>
          <!-- 商品名称 -->
          <el-form :rules="rules" ref="form" :model="formData" label-width="100px">
            <el-form-item label="商城名称：" prop="mallName">
              <el-input v-model="formData.mallName" style="width: 200px" placeholder="请输入商城名称" maxlength="9">
              </el-input>
              <div class="text margin-t10">最多不可超过9字</div>
            </el-form-item>
          </el-form>
        <div class="banner-box">
          <div class="tip-name" style="margin: 0 10px 0 16px;">
            <span style="color:#f56c6c;margin-right:4px;">*</span>
            轮播图：
          </div>
        <div class="upload-box">
          <el-upload class="banner-upload" :limit="5" :action="uploadImgUrl" :headers="header"
            :before-upload="beforeImgUpload1" :file-list="formData.fileList" list-type="picture" :on-remove="handleRemove"
            accept=".jpeg,.jpg,.png" :on-success="handleSuccess1">
            <div class="upload " v-if="formData.fileList.length < 5">上传</div>
          </el-upload>
          <div class="text margin-t10">
            建议轮播图图片宽高比上限为834x346px，最多5张，仅支持上传.jpg/.jpeg/.png格式的图片，每张大小不超过1M。
          </div>
        </div>
        </div>
          
        </div>
        <div>
          <el-button style="width:80px" type="primary" plain :disabled="activeType != 1" @click="toPath(purchaseUrl)">预览</el-button>
          <d-button    btnType="primary" v-on:debounceclick="saveData" btnTxt="发布采购专属商城"></d-button>
        </div>
        <!-- ////////////////////////////// -->
      </div>
    </el-card>
  </div>
</template>

<script>
import { epecToken } from "../../utils/globalData";
import cmsApi from "../../api/cms/index";
import cmsOssApi from "../../api/cms-oss/index.js";
import util from "../../utils/utils";
import util2 from "./utils";
import  {purchaseUrl} from '../../api/config'

export default {
  props: {
    activeType: {
      type: [String, Number],
      default: "",
    },
  },
  components: {},
  created () { },
  data () {
    return {
      purchaseUrl,
      header: epecToken,
      uploadImgUrl: cmsApi.fileUpload,
      userInfo: "",
      check1: 1,
      formData: {
        logoImgList: '',
        mallName: '',
        fileList: [],
      },
      rules: {
        mallName: [
          { required: true, message: "请输入商城名称", trigger: "blur" },
        ],
      },
      activeStep: 1,

      logoImgList: [],
      fileList: [],
      templateId: null,
      contentConfigurationIsok: false,
    };
  },
  methods: {
    async getPurchaseTemplate () {
      let params = {
        companyId: this.userInfo.companyId,
        columeId: 4, //1 首页 2 店铺   3 旗舰店
        shopId: 0,
      };
      let res1 = await cmsOssApi.getShopTemplateossUrl(params);
 
      if (res1.data && res1.data.mallName) {
 
        this.formData = {
          logoImgList:
            typeof res1.data.logoImgList == "string"
              ? [res1.data.logoImgList]
              : res1.data.logoImgList,
          fileList: res1.data.fileList,
          mallName: res1.data.mallName || null,
        };
         
      }

      let res2 = await cmsApi.queryPurchaseTemplate();
      if (res2.data) {
        let page = JSON.parse(res2.data.draftTemplate);
        // 判断logo
        if (!this.formData.logoImgList) {
          this.formData.logoImgList =
            typeof page.logoImgList == "string"
              ? [page.logoImgList]
              : page.logoImgList;
        }  
        // 判断名称
        this.formData.mallName = this.formData.mallName
          ? this.formData.mallName
          : page.mallName;

        // 判断轮播图
        if (!this.formData.fileList.length) {
          this.formData.fileList = page.fileList;
        }
        this.templateId = res2.data.templateId;
        this.contentConfigurationIsok = true;
        this.check1 = 2;
        this.$emit("getChildrenData", {
          status: this.contentConfigurationIsok,
          templateId: res2.data.templateId,
        });
 
      }
    },

    beforeImgUpload (file) {
      if(file.name && file.name.length>40){
        this.$message.warning('文件名称过长，请修改至40字以内后重新上传')
        return false
      }
      const isMaxsize = file.size / 1024 / 1024 < 0.5;
      let parmas = {
        file: file,
        typeArr: ["image/jpeg", "image/png"],
        imgMessage: "仅支持上传.jpg/.jpeg/.png格式的图片",
        isMaxsize: isMaxsize,
        sizeMessage: "上传图片大小不能超过 500k!",
        maxWidth: 300,
        maxHeight: 60,
      };
      return util.checkImgupload(parmas);
    },
    handleSuccess (res, file) {
      console.log(file);
      if (res.success) {
        this.formData.logoImgList = [];
        this.formData.logoImgList.push(res.data.url);
        this.$message.success("上传成功！");
      }
    },
    beforeImgUpload1 (file) {
      if(file.name && file.name.length>40){
        this.$message.warning('文件名称过长，请修改至40字以内后重新上传')
        return false
      }
      const isMaxsize = file.size / 1024 / 1024 < 1;
      let parmas = {
        file: file,
        typeArr: ["image/jpeg", "image/png"],
        imgMessage: "仅支持上传.jpg/.jpeg/.png格式的图片",
        isMaxsize: isMaxsize,
        sizeMessage: "上传图片大小不能超过 1MB!",
        maxWidth: 834,
        maxHeight: 346,
      };
      return util2.checkImguploadBanner(parmas);
    },
    clear () {
      this.formData.logoImgList = [];
    },
    handleRemove (file, fileList) {
      console.log(file);
      this.formData.fileList = fileList;
    },
    handleSuccess1 (res, file,fileList) {
      console.log(file);
      if (res.success) {
        // this.fileList.push({
        //   name: res.data.fileName,
        //   url: res.data.url,
        // });
        this.formData.fileList = fileList.map((item) => {
          return {
            uid:item.uid,
            link:item.link?item.link:'',
            name: item.response ? item.response.data.fileName : item.name,
            url: item.response ? item.response.data.url : item.url,

          }
        })
        this.$message.success("上传成功！");
      }
    },

    saveData () {
 
       
      if (!this.formData.logoImgList.length) {
        return this.$message.warning("请上传品牌Logo");
      }
      if (!this.formData.fileList.length) {
        return this.$message.warning("请上传轮播图");
      }
      if (!this.formData.logoImgList || this.formData.fileList.length == 0) {
        this.$message.warning("请完善采购商城内容配置");
        return;
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let obj = {
            logoImgList: this.formData.logoImgList,
            mallName: this.formData.mallName,
            fileList: this.formData.fileList,
          };
          let params = {
            // companyId: this.userInfo.companyId,
            templateId: this.templateId,
            draftTemplate: JSON.stringify(obj),
          };
          let res = await cmsApi.savePurchaseTemplate(params);
          if (res.code == 200) {
            // this.$message.success("配置成功");
            // this.getPurchaseTemplate();
            this.$emit("submitData",res.data.templateId);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // async getPurchaseTemplate2 () {
    //   let res = await cmsApi.queryPurchaseTemplate();
    //   if (res.data) {
    //     let page = JSON.parse(res.data.draftTemplate);
    //     // 判断logo
    //     this.logoImgList =
    //       typeof page.logoImgList == "string"
    //         ? [page.logoImgList]
    //         : page.logoImgList;
    //     // 判断名称
    //     this.formData.mallName = page.mallName;
    //     // 判断轮播图
    //     this.fileList = page.fileList;
    //     this.templateId = res.data.templateId;
    //     this.contentConfigurationIsok = true;
    //     this.check1 = 2;
    //     this.$emit("getChildrenData", {
    //       status: this.contentConfigurationIsok,
    //       templateId: res.data.templateId,
    //     });
    //   }
    // },

 
    toPath (url) {
      window.open(url, "_blank");
    },
  },
  computed: {
    ea_userInfo () {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    ea_userInfo: {
      immediate: true,
      handler (val) {
        if (val.companyId) {
          this.userInfo = this.$store.state.USERINFO;
          this.getPurchaseTemplate();
        }
      },
      deep: true,
    },
  },
  mounted () { },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/tip";
.upload-box{
  display: flex;
  width: 90%;
  flex-direction: column;
}
.exclusive-content {
  .upload-content {
    margin-top: 10px;
    .logo-box {
      display: flex;
    }
    .banner-box{
      display: flex;
    }
    .logo-img {
      width: 150px;
      height: 50px;
      margin: 0 20px 0 10px;
      position: relative;
      text-align: center;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;

      .cover-bg {
        display: none;
        background: rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9;

        .cover-icon {
          position: absolute;
          right: 1px;
          top: 5px;
          width: 20px;
          height: 20px;
          color: #fff;
          cursor: pointer;
        }
      }
    }

    .logo-img:hover {
      .cover-bg {
        display: block;
      }
    }

    .text {
      font-size: 12px;
      color: #666;
      line-height: 24px;
    }

    .upload {
      width: 80px;
      height: 30px;
      line-height: 30px;
      background: #2587ff;
      text-align: center;
      font-size: 14px;
      color: #fff;
    }

    .upload:hover {
      background: $main-hover;
    }

    .banner-upload {
      width: 40%;
    }
  }
}
</style>
